import styled, { css } from 'styled-components';

export const FAQListContainer = styled.div<{
  $withLegacyIndents?: boolean;
}>(
  ({ theme, $withLegacyIndents }) => css`
    ${$withLegacyIndents &&
    css`
      margin-bottom: ${theme.sz.s44};
      padding: ${theme.sz.s0} ${theme.sz.s7};
    `};

    margin-left: auto;
    margin-right: auto;

    @media (min-width: ${theme.sz.ml}) {
      max-width: ${theme.sz.lg};
      width: 100%;
    }
  `,
);

export const Title = styled.div(
  ({ theme }) => css`
    text-align: center;
    color: ${theme.co.neutral0};
    margin-bottom: ${theme.sz.s6};
    ${theme.typography.heading.mobile.m};

    @media (min-width: ${theme.sz.md}) {
      margin-bottom: ${theme.sz.s16};
      ${theme.typography.heading.desktop.l};
    }
  `,
);
